import TypeConfig from './TypeConfig';

const Utilities = {
    cdnUrl: 'https://cdn.artcld.com/img/',
    columnWidth: (columnCount) => 600 / columnCount,
    imageSize: (columnWidth) => Math.round(columnWidth * 0.82),
    imageUrl: (image, size, transforms) => {
        if (!image || !image.id) {
            return;
        }
        if (image.extension == 'gif') {
            return `${Utilities.cdnUrl}${image.id}.${image.extension}`;
        }
        let _transforms = '';
        if (size) {
            _transforms = `w_${size}`;
        }
        if (transforms) {
            if (_transforms.length > 0) {
                _transforms += ',';
            }
            _transforms += transforms;
        }
        return `${Utilities.cdnUrl}${_transforms ? `${_transforms}/` : ''}${image.id}.${image.extension}`;
    },
    isNullOrWhitespace: function (value) {
        if (!value) {
            return true;
        }
        return value.toString().trim().length == 0
    },
    maxImageWidth: (columnCount) => `${(600 / columnCount) - 36}`,
    copyObject: function (source, destination) {
        if (!source || !destination) {
            return;
        }
        for (let id in source) {
            destination[id] = source[id];
        }
    },
    _mapBorderProperty: function (style, propNameBase, propName, propValue, propUnit) {
        if (propValue == undefined || propValue == '') {
            return;
        }
        if (!style[`${propNameBase}Style`]) {
            style[`${propNameBase}Style`] = 'solid';
        }
        style[propName] = `${propValue}`;

        if (propUnit) {
            style[propName] += propUnit;
        }
    },
    mapStyleConfigProps: function (style, configProps, handleProp) {
        for (let propName in configProps) {
            let prop = configProps[propName];
            if (prop != undefined && prop.unit) {
                const propValue = (prop.value || '').trim();
                switch (propName) {
                    case 'borderBottomWidth':
                        Utilities._mapBorderProperty(style, 'borderBottom', propName, propValue, prop.unit);
                        continue;
                    case 'borderLeftWidth':
                        Utilities._mapBorderProperty(style, 'borderLeft', propName, propValue, prop.unit);
                        continue;
                    case 'borderRightWidth':
                        Utilities._mapBorderProperty(style, 'borderRight', propName, propValue, prop.unit);
                        continue;
                    case 'borderTopWidth':
                        Utilities._mapBorderProperty(style, 'borderTop', propName, propValue, prop.unit);
                        continue;
                    default:
                        if (handleProp && handleProp(propName, propValue, prop.unit)) {
                            continue;
                        }
                        break;
                }
                if (propValue != "") {
                    style[propName] = `${propValue}${prop.unit}`;
                }
                continue;
            }
            if (prop != true && prop != false) {
                if (prop && prop.toString) {
                    prop = prop.toString().trim();
                } else {
                    prop = (prop || '').trim();
                }
            }
            switch (propName) {
                case 'borderBottomColor':
                    Utilities._mapBorderProperty(style, 'borderBottom', propName, prop);
                    continue;
                case 'borderLeftColor':
                    Utilities._mapBorderProperty(style, 'borderLeft', propName, prop);
                    continue;
                case 'borderRightColor':
                    Utilities._mapBorderProperty(style, 'borderRight', propName, prop);
                    continue;
                case 'borderTopColor':
                    Utilities._mapBorderProperty(style, 'borderTop', propName, prop);
                    continue;
                default:
                    if (handleProp && handleProp(propName, prop)) {
                        continue;
                    }
                    break;
            }
            if (prop != "" && prop != "[object Object]") {
                style[propName] = prop;
            }

        }
    },

    parseImageWrapperConfig: (blockConfig, { alt, image, maxWidth } = {}) => {
        let _alt = alt;
        let _image = image;
        let isCropped, link, wrapperStyle;
        let width = maxWidth || 600;
        const contentStyle = { textAlign: 'center' };
        const imageStyle = { display: 'inline', maxWidth: '600px', paddingBottom: 0, verticalAlign: 'bottom' };
        if (blockConfig) {
            if (blockConfig.block) {
                if (blockConfig.block.image && blockConfig.block.image.width) {
                    width = Math.min(blockConfig.block.image.width, width);
                }
                Utilities.mapStyleConfigProps(imageStyle, blockConfig.block, (propName, propValue) => {
                    switch (propName) {
                        case 'alt':
                            _alt = propValue || _alt;
                            return true;
                        case 'backgroundColor':
                            if (propValue) {
                                wrapperStyle = { backgroundColor: propValue };
                            }
                            return true;
                        case 'image':
                            _image = blockConfig.block.image;
                            return true;
                        case 'isCropped':
                            isCropped = propValue;
                            return true;
                        case 'url':
                            link = propValue;
                            return true;
                    }
                });
            }
            if (blockConfig.layout) {
                Utilities.mapStyleConfigProps(contentStyle, blockConfig.layout, (propName, propValue) => {
                    switch (propName) {
                        case 'paddingLeft':
                        case 'paddingRight':
                            if (propValue) {
                                width -= propValue;
                            }
                            break;
                    }
                });
            }
        }
        if (imageStyle.borderLeftWidth && imageStyle.borderLeftStyle != 'none') {
            const temp = parseInt(imageStyle.borderLeftWidth, 10);
            if (!isNaN(temp)) {
                width -= temp;
            }
        }
        if (imageStyle.borderRightWidth && imageStyle.borderRightStyle != 'none') {
            const temp = parseInt(imageStyle.borderRightWidth, 10);
            if (!isNaN(temp)) {
                width -= temp;
            }
        }
        return { alt: _alt, contentStyle, image: _image, imageStyle, isCropped, link, width, wrapperStyle }
    },
    parseTextWrapperConfig: (blockConfig) => {
        let innerStyle, wrapperStyle;
        const contentContainerStyle = { borderCollapse: 'separate', maxWidth: '100%', minWidth: '100%' }
        const contentStyle = { fontFamily: TypeConfig.defaultFontFamily };
        if (blockConfig) {
            if (blockConfig.block) {
                Utilities.mapStyleConfigProps(contentContainerStyle, blockConfig.block, (propName, propValue) => {
                    switch (propName) {
                        case 'backgroundColor':
                            wrapperStyle = { backgroundColor: propValue };
                            return true;
                        case 'contentColor':
                            contentContainerStyle.backgroundColor = propValue;
                            return true;
                        case 'design':
                            return true;
                    }
                });
            }
            if (blockConfig.layout) {
                Utilities.mapStyleConfigProps(contentStyle, blockConfig.layout, (propName, propValue, propUnit) => {
                    switch (propName) {
                        case 'marginBottom':
                        case 'marginLeft':
                        case 'marginRight':
                        case 'marginTop':
                            if (propValue && propUnit) {
                                if (!innerStyle) {
                                    innerStyle = {};
                                }
                                innerStyle[propName.replace('margin', 'padding')] = `${propValue}${propUnit}`;
                            }
                            return true;
                    }
                });
            }
        }
        return { contentContainerStyle, contentStyle, innerStyle, wrapperStyle };
    }
}

export default Utilities;